import { useContext, useEffect, useState } from "react";
import { Divider, Grid, Typography } from "@material-ui/core";
import { ChangeLocaleButton } from "../ChangeLocalButton/ChangeLocalButton";
import logo from "../../Assets/Images/aptor.svg";
import { useStyles } from "./Home.styles";
import { Logo } from "../Logo/Logo";
import { LogoutBUtton } from "./Components/LogoutButton/LogoutButton";
import MLSImg from '../../Assets/Images/MLS.png';
import OrganisationImg from '../../Assets/Images/organisation.png';
import { CardLink } from "./Components/CardLink/CardLink";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { Container } from "../Container/Container";
import { FormattedMessage } from 'react-intl';
import { getAppConfiguration } from "../../Config";
import { useDispatch } from "react-redux";
import UserSevicesApi from "../../Redux/Actions/UserAction";
import { useSelector } from "react-redux";
import { TabTitle } from "../../Utilities";
import { useSnackbar } from 'notistack';
import { Loading } from "../Loader/Loading";
import { Hidden } from "@mui/material";
import { ImpersonationForm } from "./Components/ImpersonationForm/ImpersonationForm";
import { UserContext } from "../../Context/UserContext/UserContext";
const Home = () => {
  TabTitle('aptor')
  const classes = useStyles();
  const { instance, accounts } = useMsal();
  const current = instance.getActiveAccount();
  const isAuthenticated = useIsAuthenticated();
  const appConfig = getAppConfiguration();
  const dispatch: any = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { currentUser } = useSelector((state: any) => ({
    currentUser: state.UserReducer.currentUser,
  }))
  const [expireToken, setExpireToken] = useState<string>('');
  const [loaing, setLoading] = useState(true)
  const { impersonateUser, userImpersonation } = useContext(UserContext);
  // const parseJwt = (teken: any) => {
  //   try {
  //     return JSON.parse(atob(teken.split('.')[1]));
  //   } catch (e) {
  //     return null;
  //   }
  // };
  // useEffect(() => {
  //   //loginHandle();
  //   const accessTokenRequest = {
  //     scopes: appConfig.scopes,
  //     account: accounts[0],
  //   };
  //   dispatch(UserSevicesApi.GetToken(instance,accessTokenRequest));
  //   const tokenAccess = async () => {
  //       await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse) => {
  //         let accessToken = accessTokenResponse.accessToken;
  //         setExpireToken(accessToken);
  //         let user= {
  //           firstName: current?.idTokenClaims?.given_name,
  //           lastName: current?.idTokenClaims?.family_name,
  //           email: current?.idTokenClaims?.email,
  //           b2CAccountId: current?.localAccountId
  //         }
  //         setLoading(true)
  //         dispatch(UserSevicesApi.usersCallApiToken(user, accessToken,instance,enqueueSnackbar));
  //         dispatch(UserSevicesApi.UserListData(currentUser?.customerId, accessToken,enqueueSnackbar));
  //         setTimeout(() => {
  //           if(currentUser?.firstName){
  //             setLoading(false);
  //           }
  //         },3000);
  //       }).catch((error) => { console.log(error, "===>get token error home") })
  //   }
  //    tokenAccess();
  //    Token();
  // }, [instance, accounts]);
  // const Token = ()=>{
  //   if (expireToken) {
  //     const decodedJwt = parseJwt(expireToken);
  //     if (decodedJwt.exp * 1000 < Date.now()) {
  //       instance.logoutRedirect();
  //       localStorage.clear();
  //     }
  //   }
  // }
  const loginHandle = async () => {
    await instance.handleRedirectPromise();
    if (accounts.length === 0) {
      await instance.loginRedirect({
        scopes: getAppConfiguration().scopes
      })
    }
  }
  return (
    <div>
      {currentUser?.error ? <div><Loading open={true} /></div> : <>
        {/* {(isAuthenticated && currentUser?.role)&&(<> */}
        <Hidden only="xs">
          <Grid
            className={`${classes.topMenu} Home-topmenu-container`}
            container
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Logo src={logo} alt="Aptor logo" disablePadding />
            </Grid>
            {userImpersonation == undefined && currentUser?.role == "Admin" && (
              <Grid item sm={6}>
                <ImpersonationForm />
              </Grid>
            )}
            <Grid item>
              <ChangeLocaleButton />
              <LogoutBUtton />
            </Grid>
          </Grid>
        </Hidden>
        <Hidden smUp>
          <Grid
            className={classes.topMenuMobile}
            container
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Logo src={logo} alt="Aptor logo" disablePadding small />
            </Grid>
            <Grid item>
              <ChangeLocaleButton />
              <LogoutBUtton />
            </Grid>
          </Grid>
          <Divider />
          {userImpersonation == undefined && currentUser?.role == "Admin" && (
            <ImpersonationForm />
          )}
        </Hidden>
        <Container>
          <Typography className={classes.heading} variant="h1" align="center" color="primary" gutterBottom>
            <FormattedMessage
              id="component.home.welcome"
              defaultMessage="Start page"
              description="Welcome message"
            />
            {currentUser?.firstName}!
            {/* {current?.idTokenClaims?.given_name == "" || current?.idTokenClaims?.given_name == undefined ? currentUser?.firstName : current?.idTokenClaims?.given_name}! */}
          </Typography>
          <Typography className={classes.subHeading} variant="h2" align="center">
            <FormattedMessage
              id="component.home.chooseModule"
              defaultMessage="Choose module to work with"
              description="Choose module message"
            />
          </Typography>
          <Grid container spacing={2} justifyContent="center">
            {currentUser?.role === "Admin" ? <>
              <CardLink link="/administration/customers" label="component.home.administration" image={OrganisationImg} /></> : null
            }
            {currentUser?.role === "User" ? <CardLink link="/ms/document" label="component.home.MLS" image={MLSImg} /> : null}
            {currentUser?.role === "ClientAdmin" ? <CardLink link="/ms/document" label="component.home.MLS" image={MLSImg} /> : null}

          </Grid>
          {/* </>} */}
        </Container>
        {/* </>)} */}
      </>}
    </div>
  );
};
export default Home;